import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useGenres } from '../../hooks/useGenres';
import SectionHeader from '../ui/SectionHeader';

const emoji = ['📖', '🧭', '🐉', '🚀', '💞', '🔍', '📜', '🌱', '🏛️', '📈'];

export default function GenreHighlights() {
  const genres = useGenres({ withBooks: true });

  if (genres.length === 0) return null;

  return (
    <section className="container-app py-10">
      <SectionHeader chapter="06" title="Browse by genre" />
      <div className="flex flex-wrap gap-3">
        {genres.map((g, i) => (
          <motion.div
            key={g}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3, delay: i * 0.03 }}
          >
            <Link
              to={`/shop?genre=${encodeURIComponent(g)}`}
              className="flex items-center gap-2 rounded-full border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 px-5 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-200 transition-all hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 dark:hover:bg-white/10"
            >
              <span>{emoji[i % emoji.length]}</span> {g}
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
